import { Component, OnInit } from '@angular/core'; // , Input

@Component({
  selector: 'app-navigation-internal',
  templateUrl: './navigationInternal.component.html?v=001',
  styleUrls: ['./navigationInternal.component.scss?v=001'],
})

export class NavigationInternalComponent implements OnInit {
  showInternalSection: boolean;


 // @Input() internal: boolean;


ngOnInit() {
}
  // if (internal) {
  //   this.showInternalSection = internal; // don't need this
  //   // get database values
  // }

}



// WEBPACK FOOTER //
// ./src/app/navigationInternal/navigationInternal.component.ts